import EcoLink from 'eco-design/base/eco-link';
import css from './index.module.scss';
import { ItfProductRecommandProps, ItfProductAPI, ItfProductParamId } from './type';
import { getI18n } from './i18n';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { getItems } from './api';
// import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import { arrow } from './icon';

const ProductRecommand: React.FC<ItfProductRecommandProps> = ({ theme = 'white', className = '', more = '', data = [] }) => {
    const { locale = '' } = useRouter();
    const { also_like, view_more, learn_more } = getI18n(locale);
    const [items, setItems] = useState<ItfProductAPI[]>([]);
    const [gap, setGap] = useState(0);

    const init = async () => {
        const tmp = await getItems(data, locale);
        setItems(tmp?.filter((i: ItfProductAPI) => i.variantId));
        // setItems(tmp);
    };

    useEffect(() => {
        init();
    }, [data]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth > 1440 ? 40 : window?.innerWidth > 1024 ? 24 : 12);
        }
    }, []);

    return (
        <section className={`${css['product-recommand']} product-recommand theme-${theme}${className ? ` ${className}` : ''}`}>
            <div className="section-header">
                <p className="section-label">{also_like}</p>
                {more && (
                    <EcoLink
                        className="section-link GtmModuleData-btn-href"
                        href={more}
                        dataLayer={{
                            __btn_id1: 'product-recommand',
                            __btn_id2: more,
                            __btn_type: 'href',
                        }}
                    >
                        <span>{view_more}</span>
                        {arrow}
                    </EcoLink>
                )}
            </div>
            <div className="section-products">
                <Swiper
                    className="items"
                    // modules={[Scrollbar, Navigation]}
                    // navigation={true}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    // scrollbar={{
                    //     draggable: true,
                    // }}
                >
                    {items?.map((item: ItfProductAPI, k: number) => (
                        <SwiperSlide className="item" key={k}>
                            <div className="item-img">
                                <EcoImg pc={item?.variantImg || item?.img} alt={item?.skuTitle || item?.productTitle} />
                            </div>
                            <p className="item-name">{item?.skuTitle || item?.productTitle}</p>
                            <EcoLink
                                className="item-link GtmModuleData-btn-href"
                                href={`https://${locale}.ecoflow.com/products/${item?.handle}?variant=${item?.variantId}`}
                                dataLayer={{
                                    __btn_id1: 'product-recommand',
                                    __btn_id2: `https://${locale}.ecoflow.com/products/${item?.handle}?variant=${item?.variantId}`,
                                    __btn_type: 'href',
                                }}
                            >
                                <span>{learn_more}</span>
                                {arrow}
                            </EcoLink>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default ProductRecommand;
